import { Component, EventEmitter, Output, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Common } from '../../shared/common';

@Component({
  selector: 'app-suspend-popup',
  templateUrl: './suspend-popup.component.html',
  styleUrls: ['./suspend-popup.component.less', '../../shared/common.less']
})
export class SuspendPopupComponent implements OnChanges {
  @Output() isClosed = new EventEmitter<boolean>();
  @Output() suspendMessage = new EventEmitter<string>();
  @Output() sendAssessorKey = new EventEmitter<{}>();
  @Input() isResend = true;
  @Input() isAssessors = false;
  @Input() assessors = []
  @Input() suspendErrorMessage: Array<string> = ['', '', ''];
  @Input() suspendActiveAssessors: Array<{ email: string, code: string }> = [];
  messageLength = 0
  otpCodes: string[] = []
  isSuspendReady: boolean = false;


  constructor(public common: Common) { }

  ngOnChanges(changes: SimpleChanges) {
    // Vérifier si la suspension est prête quand les assesseurs actifs changent
    if (changes['suspendActiveAssessors']) {
      this.checkSuspendReady();
    }
  }

  checkSuspendReady() {
    this.isSuspendReady = this.messageLength > 0 && (this.suspendActiveAssessors.length > (this.assessors.length / 2) || this.assessors.length === 0);
    // if (this.messageLength > 0 && this.suspendActiveAssessors.length >= (this.assessors.length / 2)) {
    //   this.isSuspendReady = true;
    // } else {
    //   this.isSuspendReady = false;
    // }
  }

  onDismiss(event: boolean) {
    this.isClosed.emit(event);
  }

  onMessageInput(event: { target: { value: string } }) {
    this.messageLength = event.target.value.length;
    this.suspendMessage.emit(event.target.value);
    this.checkSuspendReady();
  }

  onCodeInput(value: string, index: number) {
    this.otpCodes[index] = value;

    if (value && value.length === 6) {
      this.sendAssessorKey.emit({ email: this.assessors[index].email, code: value, index: index });
    }
  }

  isAssessorActive(assessorEmail: string): boolean {
    return this.suspendActiveAssessors.some(active => active.email === assessorEmail);
  }
}
